module.exports = __webpack_public_path__ + "static/media/23import-51.3bd49bd3.xlsx";